import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const PontoRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--ponto']}>
    <Route index element={<Index />} />
  </SubRouter>
))
